export default __webpack_public_path__ + "static/media/feature-bg.0119b2b9.jpg";